<template>
  <div class="profile-like" @click="like($event)" :class="active ? 'active' : ''"
    :data-original-title="active ? 'Profil aus Favoriten entfernen' : 'Profil in Favoriten speichern'"
    data-toggle="tooltip" data-placement="top">
    <i class="fa-heart" :class="active ? 'fas' : 'far'"></i>
  </div>
</template>
  
<script>
export default {
  props: {
    dataActive: {
      default: false,
      type: Boolean,
    },
    dataUserId: {
      required: true,
      type: Number,
    },
    dataGuest: {
      required: true,
      type: Boolean,
    }
  },
  data() {
    return {
      active: this.dataActive,
    };
  },
  methods: {
    like(event) {
      if (this.dataGuest) {
        window.location.href = '/anmelden';
        return;
      }
      if (this.active) {
        this.active = false;
        $(event.target).tooltip('hide');
        axios.post("/api/likes/destroy", { user_id: this.dataUserId }).then((response) => {
          if (response.status != 200) {
            alert(
              "Es ist ein Fehler aufgetreten. Fehlercode: " + response.status
            );
          }
        });
      } else {
        this.active = true;
        $(event.target).tooltip('hide');
        axios.post("/api/likes", { user_id: this.dataUserId }).then((response) => {
          if (response.status != 200) {
            alert(
              "Es ist ein Fehler aufgetreten. Fehlercode: " + response.status
            );
          }
        });
      }
    },
  },
};
</script>
  